import { generateDatadogTrackingProps } from 'toolkit/environment/environment/userMonitoring.util';
import './app-router-template.scss';

import { IconButton, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';
import {
  actingUserAppSelectors,
  stopImpersonatingGuide,
} from 'redux/slices/actingUserSlice.slice';
import { useAppDispatch } from 'redux/storeHooks';
import { IconLibrary } from '@act/storybook';

const AppRouterTemplate = () => {
  const actingUserState = actingUserAppSelectors.useSelectActingUserState();
  const dispatch = useAppDispatch();
  const handleStopImpersonating = () => {
    dispatch(stopImpersonatingGuide());
  };
  if (actingUserState.impersonatedUserId) {
    return (
      <div className="impersonating-user">
        <div className="control">
          <Typography variant="titleMedium">Impersonation Mode</Typography>
          <div>
            <IconButton {...generateDatadogTrackingProps('app-router-template-icon-button-stop-impersonating')} onClick={() => handleStopImpersonating()}>
              <IconLibrary
                iconName="X"
                size={16}
                weight="bold"
                color="primary"
                useContrastColor
              />
            </IconButton>
          </div>
        </div>
        <div className="app-wrapper">
          <Outlet />
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default AppRouterTemplate;
